export default {
  All: 'All',
  Rented: 'Rented',
  Idle: 'Idle',
  meau: {
    back: '公式サイトに戻る',
    nav1: 'オリオン競技',
    nav2: '長期レンタルモード',
    nav3: '短期レンタルモード',
    nav4: 'デバイスリスト',
  },
  footer: {
    link: '詳細はこちら',
    community: 'コミュニティをフォローする',
    tip: '説明：コミュニティにはTwitter、Telegram、Reddit、Medium、Discord、TikTok、YouTubeが含まれます',
  },

  home: {
    title1: 'Orion',
    title2: 'GPU計算パワー競技',
    text: 'DeepLinkプロトコルのOrion GPU算力コンペティションは、マイナーがDeepLinkネットワークのテストに積極的に参加することを奨励するための重要なインセンティブコンペティションです。このコンペティションは、世界最大のクラウドゲームプロトコルプラットフォームであるDeepLinkの正式な開始に向けた重要な準備ステップであり、将来のグローバルユーザーに対して堅固な技術基盤と効率的な算力サポートを提供します',
    text1: '現在、DeepLinkネットワーク内のGPUの総数は{gpu_num}枚です',
    text2: 'コンテストが開始しました。GPUの数が基準に達すると報酬が開始されます！',
    btn_text1: '長期レンタルモード競争 - 終了',
    btn_title1: '現在の {long_term} GPUs',

    btn_text2: '短期レンタルモード競技 - フェーズ4',

    btn_title2: '現在 {short_term} GPUs',
    cont2_text1:
      'Orion計算パワー競技のトークン報酬総額は30億枚で、長期レンタルモードには20億DLC、短期レンタルモードには10億DLCが割り当てられ、期間は180日間です。競技は3回に分かれており、それぞれ60日間続き、5〜10日の間隔があります。',
    cont2_btn1: '長期レンタルモード',
    cont2_btn2: '短期レンタルモード',
    cont3: {
      text1: '総計算パワー値',
      text2: 'GPU総数',
      text3: '計算プール総数',
      text4: 'GPUレンタル率',
      text5: 'DLC報酬の合計',
      text6: 'DLC焼却数',
      text7: 'マイナーのために質押されたDLC数',
      text8: 'オンラインGPU数',
      text9: 'オンラインGPU使用率',
    },
    cont4: {
      li1: '競技ランキング',
      li2: 'マイナー名',
      li3: '計算パワー',
      li4: 'GPUの数',
      li5: 'レンタル率',
      li6: 'レンタル数',
      li7: 'アンロックされた報酬数',
      li8: '総報酬数',
      li9: 'オンラインGPU数',
      li10: 'オンラインGPU使用率',
    },
  },
  long_rule: {
    title: '長期レンタルモード競技規則',
    text1: '現在、DeepLinkネットワークの長期レンタルモードにおけるGPUの総数は{long_num}です',
    text2:
      '競技期間中、マイナーは合計20億DLCの報酬を受け取ることができ、ユーザーが支払ったDLCレンタル料の100％が焼却されます',
    competition_phase_two_in_progress: '競技の第二段階が進行中です',
    cont2: {
      title: '1. 参加ルール',
      text1_1: 'オリオン計算パワー競技に参加するマイナーは、ノードNFTを所有する必要があります（ノードの詳細はこちら：',
      text1_2:
        '）。競技期間中、1台のGPUマシンは複数のノードを保持でき、報酬トークンの数はノードの数に比例します。1台のマシンあたりのノードNFTの上限は20個です。',
      text2_1:
        'GPUサーバーの最低要件：\n 計算パワーサーバーは最低要件を満たす必要があり、\n 検証人の審査を通過してオンラインになることができます。それ以外の場合、収益を得ることはできません。',
      text3_1: 'GPU',
      text3_2: 'Nvidiaシリーズのグラフィックスカードである必要があります。20、30、40、50シリーズのモデル',
      text4_1: 'メモリ',
      text4_2: '最低要件は1カードあたり16Gで、32G推奨',
      text5_1: 'CPU',
      text5_2:
        'クラウドゲーミングの要件を満たす必要があります：Intel/AMD、メイン周波数3.0GHzまたはターボ周波数3.5GHz以上; 各GPUは個別のCPUを必要とし、Black Myth: Wukongをスムーズに実行できる必要があります。例：Intel 10世代以上、AMD 5600以上',
      text6_1: 'ハードディスク',
      text6_2: 'システムディスクは100G SSD以上、データディスクは3T SSD以上、またはディスクレスシステムを使用する',
      text7_1: '位置',
      text7_2:
        '不安定なネットワークと電力によるペナルティを避けるために、マシンをIDCデータセンターに設置することをお勧めします',
      text8_1: 'ネットワーク帯域幅',
      text8_2: '各GPUマシンには最低10Mのアップストリーム帯域幅を持つことをお勧めします',
    },
    cont3: {
      title: '2. 計算パワーの計算ルール',
      text: 'エコシステム全体におけるユーザー端末のレンタル料金は、計算パワー値システムの価格設定に基づいて統一されています。DLCのレンタル収入は0.6米ドル/C/月です。計算モデルは以下の通りです：全体の計算パワー値=(25 * カード数 + メモリ/3.5 + (√(CUDAコア数) * √(メモリ/10)) * GPU数)、ローカル領域係数が1の場合、計算パワー値は次の通りです：',
      li1: 'GPUタイプ',
      li2: 'CUDAコア',
      li3: 'メモリ',
      li4: 'GPUの数',
      li5: 'メモリ（G）',
      li6: '全体の計算パワー（C）',
      li7: '全体のレンタル料（USD）',
      li8: 'カードあたり月額レンタル料（USD）',
    },
    cont4: {
      title: '3. 地域係数',
      li1: '地域',
      li2: '係数',
      li_text1: '中国本土',
      li_text2: '北アメリカ',
      li_text3: '南アメリカ',
      li_text4: 'ヨーロッパ',
      li_text5: '中東',
      li_text6: '韓国',
      li_text7: '日本',
      li_text8: '台湾、中国',
      li_text9: '香港とマカオ、中国',
      li_text10: 'マレーシア',
      li_text11: 'インドネシア',
      li_text12: 'シンガポール',
      li_text13: 'ベトナム',
      text1:
        '機械の計算パワー計算式: (25 * カード数 + メモリ/3.5 + (√(CUDAコア数) * √(メモリ/10)) * GPU数) * 地域係数 * 大規模モデル係数',
      text2: '機械モデル:',
      text3: 'GPUの数:',
      text4: 'メモリサイズ:',
      text5: '地域:',
      text6: '選択してください',
      text7: '現在の機械の計算パワー値は: {total}',
    },
    cont5: {
      title:
        '4. 報酬メカニズム（DBC AIパブリックチェーンのEVM互換DLCに基づく、ブラウザアドレス：https://test.dbcscan.io/）',
      text1:
        'オリオン計算パワー競技におけるIDC長期レンタルモードのGPUマシンに対するトークン報酬の総額は20億枚で、期間は180日間です。競技は3回に分かれており、それぞれの間隔は5〜10日です。',
      text2: '競技1：各タイプのGPUの数が{n_gpu1}台に達したときに競技が正式に開始されます。',
      text3: '60日間、1日あたり600万枚、10％は即時受け取り、90％は180日間で解放され、1日あたり0.5％が解放されます。',
      text4: '競技2：各タイプのGPUの数が{n_gpu2}台に達したときに競技が正式に開始されます。',
      text5: '60日間、1日あたり800万枚、10％は即時受け取り、90％は180日間で解放され、1日あたり0.5％が解放されます。',
      text6: '競技3：各タイプのGPUの数が{n_gpu3}台に達したときに競技が正式に開始されます。',
      text7: '60日間、1日あたり1,933万枚、10％は即時受け取り、90％は180日間で解放され、1日あたり0.5％が解放されます。',
      text8: '取引所に上場後、テストトークンは1：1の比率でメインネットトークンに交換できます。',
      text9: 'DeepLinkは非線形報酬アルゴリズムを使用しています。',
      text10:
        'このシステムの報酬トークンの総量は毎日固定されています。マシンが得る報酬は、マシンの計算能力X、マイニングの有効時間Y、およびステークされたトークン数に関連しています。ステークされたトークンが多いほど報酬も多くなりますが、線形の増加関係にはなりません。0～10,000トークンの報酬基準は同じですが、10,000トークンを超えると関数に基づいて報酬が計算されます。マシンがレンタル状態にある場合、計算能力が30％増加します。',
      text11: '報酬計算式：',
      text12: 'R：毎日の報酬トークン総数（固定値）',
      text13: 'マシンiのステークされたトークン数',
      text14: 'マシンiの計算能力',
      text15: 'マシンiの有効マイニング時間',
      text16: '',
      title1: 'ステーク数：',
      text1_1: '1）任意のステーク数を選択するか、ステークしないことも選択できます。',
      text1_2: '2）ステーク数が0～10,000の範囲であれば、報酬量は同じです。10,000を超えると報酬は非線形に増加します。',
      text1_3:
        '3）ステーク数が10,000未満の場合、各報酬の抽出はまずステークに充当され、10,000が満たされるまで続きます。',
      text1_4:
        '4）100,000トークンの報酬は、10,000トークンのステークの1.23026倍で、約23.03％の増加です。1,000,000トークンの場合は1.46052倍で、約46.05％の増加です。10,000,000トークンの場合は1.69078倍、約69.08％の増加であり、100,000,000トークンの場合は1.92103倍、約92.10％の増加です。',
      title2: '報酬の引き出し：',
      text2_1:
        '24時間ごとに報酬を引き出すことができます。各引き出し時に、新たに発生した報酬の10％が即座に引き出し可能で、残りの90％は180日間ロックされます。ロックされた部分は各引き出し時に0.5％ずつリリースされ、180日後には完全にリリースされます。',
      block_title1: '特別注意:',
      block_text1_1: '長期レンタルモードでは、まずGPUマシンをDBCネットワークに追加する必要があります。参考資料:',
      block_text1_2:
        '。その後、マイナーはマシンを自らレンタルする必要があり、それによってDLCネットワークに参加してDBCおよびDLCの両方の収益を得ることができます。DBCネットワークに参加した後のDBC収益 = DBC報酬 - 30％のレンタル料。',
      block_title2: 'マシンの1日あたりのDBC収益計算式:',
      block_text2:
        '全マシンの計算能力 / ネットワーク全体の計算能力 * 547,945 * DBC価格 * 地域係数 * 1.3 (レンタルされた場合、計算能力が30％増加) - 全マシンの計算能力 * 地域係数 * 0.01693 * 30％ (1日あたりの単位計算能力の収益は0.01693 USD)。',
      text3_13:
        '現在の1日あたりの収益は: {usdt1} USD相当のDBC = オンチェーン報酬: {dbc} DBC (現在のDBC価格 {dbc_price} USDのとき {usdt2} USDに相当) - 30％のレンタル料: {usdt3} USD相当のDBC。',
      title4: 'マシンの1日あたりのDLC収益計算式: DLCは{price} USDで計算。',
      text4_1: 'GPUモデル:',
      text4_2: 'メモリサイズ:',
      text4_3: 'ノードNFTの数:',
      text4_4: '地域:',
      text4_5: 'ステークされたDLCの量:',
      text4_6: '競技フェーズ:',
      text4_6_1: 'フェーズ1: 1日あたり600万DLC。',
      text4_6_2: 'フェーズ2: 1日あたり800万DLC。',
      text4_6_3: 'フェーズ3: 1日あたり1933万DLC。',
      text4_7: '参加GPUの総数:',
      text4_8: '(総GPUは4060モデル、32GB、平均10個のNFT、および平均ステーク10万トークンに基づいて一律に計算されます)',
      title5: 'オンチェーン報酬: {dlc_num} DLC (現在のDLC価格{price} USDで {usdt_num} USDに相当)。',
      req_title1: '5. 通報および検証メカニズム (DBC AIパブリックチェーンのEVM互換のDLCに基づく)',
      req_text1:
        'DLCマシンをレンタルしているユーザーは、いつでも通報を開始できます。通報を開始するには、10000DLCのデポジットが必要です。通報時には、通報情報がDBCのバリデーター検証プロセスに入ります。',
      req_title2: '6. 罰則メカニズム (DBC AIパブリックチェーンのEVM互換のDLCに基づく)',
      req_text2:
        'DLCの通報が検証された後、問題があった場合、ルールに従ってDBCステークトークンが差し引かれます。最大で10000DLCが差し引かれ、これらのステークトークンは通報者に報酬として与えられます。',
      req_title3: '7. 支払いおよび燃焼メカニズム (DBC AIパブリックチェーンのEVM互換のDLCに基づく)',
      req_text3:
        'ユーザーはDLCを支払い、GPU価格がDBCネットワークより20％高いDLCネットワークでマシンのレンタル権を取得します。支払われたDLCは100％スマートコントラクトで燃焼され、各支払いと燃焼記録を確認できます。',
    },
  },
  short_rule: {
    title: '短期レンタルモード競技ルール',
    text1: 'DeepLinkネットワークにおける短期レンタルモードのGPU総数は現在 {short_num} です。',
    text2:
      '競技期間中、マイナーは合計10億DLCの報酬を受け取ることができ、ユーザーが支払うDLCレンタル料金は100％焼却されます。',
    competition_phase_two_in_progress: '競技の第四段階が進行中です',
    cont2: {
      title: '1. 参加ルール',
      text1_1: 'オリオン計算能力競技に参加するマイナーは、ノードNFTを保有する必要があります（ノードの詳細について：',
      text1_2:
        '）。競技期間中、1台のGPUマシンで複数のノードを保有することができ、報酬トークンの数はノードの数に比例します。1台のマシンが保有できるノードNFTの最大数は20です。',
      text2_1: 'GPUサーバーの最低要件： \n 計算能力サーバーのパラメータは最低要件を満たす必要があります。',
      text3_1: 'GPU',
      text3_2: 'Nvidiaシリーズのグラフィックスカードでなければなりません。対象モデルは20、30、40、50シリーズです。',
      text4_1: 'メモリ',
      text4_2: '最低メモリ要件は各カード16Gで、32Gを推奨します。',
      text5_1: 'CPU',
      text5_2:
        'クラウドゲームの要件を満たす必要があります：Intel/AMDでベースクロックが3.0GHz以上、またはブーストクロックが3.5GHz以上。各GPUには個別のCPUが必要で、「Black Myth: Wukong」をスムーズに実行できること。例：Intel第10世代以上、AMD 5600以上。',
      text6_1: 'ハードドライブ',
      text6_2: 'システムディスク2T SSD以上、データディスク1T以上',
      text7_1: '設置場所',
      text7_2: 'マシンは自宅に設置することができます。',
      text8_1: 'ネットワーク帯域幅：',
      text8_2: '各GPUマシンは少なくとも10Mのアップロード帯域幅が必要です。',
    },
    cont3: {
      title: '2. 計算能力の計算ルール',
      text: 'エコシステム全体で、ユーザーのレンタル料金は計算能力値の価格設定システムに基づいて統一されています。DLCレンタル収益は0.508 USD/C/月です。計算モデルは以下の通りです：全体のマシンの計算能力値 = (25 * カード数 + メモリ/3.5 + (√(CUDAコアの数) * √(ビデオメモリ/10)) * グラフィックスカードの数)。',
    },
    cont4: {
      title: '3. 地域係数',
      li1: '地域',
      li2: '係数',
      li_text1: '中国本土',
      li_text2: '北アメリカ',
      li_text3: '南アメリカ',
      li_text4: 'ヨーロッパ',
      li_text5: '中東',
      li_text6: '韓国',
      li_text7: '日本',
      li_text8: '台湾、中国',
      li_text9: '香港とマカオ、中国',
      li_text10: 'マレーシア',
      li_text11: 'インドネシア',
      li_text12: 'シンガポール',
      li_text13: 'ベトナム',
      text1:
        '機械の計算パワー計算式: (25 * カード数 + メモリ/3.5 + (√(CUDAコア数) * √(メモリ/10)) * GPU数) * 大規模モデル係数',
      text2: '機械モデル:',
      text3: 'GPUの数:',
      text4: 'メモリサイズ:',
      text5: '地域:',
      text6: '選択してください',
      text7: '現在の機械の計算パワー値は: {total}',
    },
    cont5: {
      title:
        '4. 報酬メカニズム（DBC AIパブリックチェーンのEVM互換DLCに基づく、ブラウザアドレス：https://test.dbcscan.io/）',
      text1:
        'オリオン計算能力競技の個別短期レンタルGPUマシンのトークン報酬総額は10億枚で、180日間続きます。競技は3回に分かれており、それぞれの間隔は5〜10日です。',
      text2: '競技フェーズ1：各タイプのGPUが{n_gpu1}台に達した場合にのみ、競技が正式に開始されます。',
      text3:
        '60日間、1日あたり300万トークン、10％が即時にアンロックされ、90％が180日間かけてアンロックされ、毎日0.5％がアンロックされます。',
      text4: '競技フェーズ2：各タイプのGPUが{n_gpu2}台に達した場合にのみ、競技が正式に開始されます。',
      text5:
        '60日間、1日あたり400万トークン、10％が即時にアンロックされ、90％が180日間かけてアンロックされ、毎日0.5％がアンロックされます。',
      text6: '競技フェーズ3：各タイプのGPUが{n_gpu3}台に達した場合にのみ、競技が正式に開始されます。',
      text7:
        '60日間、1日あたり966.5万トークン、10％が即時にアンロックされ、90％が180日間かけてアンロックされ、毎日0.5％がアンロックされます。',
      text8: '取引所に上場後、テストトークンは1：1の比率でメインネットトークンに交換できます。',
      text9: 'DeepLinkは非線形報酬アルゴリズムを使用しています。',
      text10:
        'このシステムの報酬トークンの総量は毎日固定されています。マシンが得る報酬は、マシンの計算能力X、マイニングの有効時間Y、およびステークされたトークン数に関連しています。ステークされたトークンが多いほど報酬も多くなりますが、線形の増加関係にはなりません。0～10,000トークンの報酬基準は同じですが、10,000トークンを超えると関数に基づいて報酬が計算されます。マシンがレンタル状態にある場合、計算能力が30％増加します。',
      text11: '報酬計算式：',
      text12: 'R：毎日の報酬トークン総数（固定値）',
      text13: 'マシンiのステークされたトークン数',
      text14: 'マシンiの計算能力',
      text15: 'マシンiの有効マイニング時間',
      text16: '',
      title1: 'ステーク数：',
      text1_1: '1）任意のステーク数を選択するか、ステークしないことも選択できます。',
      text1_2: '2）ステーク数が0～10,000の範囲であれば、報酬量は同じです。10,000を超えると報酬は非線形に増加します。',
      text1_3:
        '3）ステーク数が10,000未満の場合、各報酬の抽出はまずステークに充当され、10,000が満たされるまで続きます。',
      text1_4:
        '4）100,000トークンの報酬は、10,000トークンのステークの1.23026倍で、約23.03％の増加です。1,000,000トークンの場合は1.46052倍で、約46.05％の増加です。10,000,000トークンの場合は1.69078倍、約69.08％の増加であり、100,000,000トークンの場合は1.92103倍、約92.10％の増加です。',
      text2_1_line1:
        '報酬はいつでも引き出すことができます。最初にDLCをステーキングしていない、または10,000未満の場合、報酬は10,000DLCに達するまでステーキングされます。',
      text2_1_line2: '1) 賃料収益は10,000DLCに達するまでステーキング保証金として蓄積されます。',
      text2_1_line3:
        '2) 最低レンタル時間は2時間で、最大時間には制限がありません。残り時間が1時間未満の場合はレンタルできず、オンライン報酬の対象外となります。マイナーはいつでも時間を延長できますが、各延長は最低2時間である必要があります。',

      title4: '1日あたりのDLC収益計算式：DLCは{price} USDで計算されます。',
      text4_8: '(総GPUは4060 32Gを基準に統一して計算され、平均10個のNFTと平均10,000トークンのステークで計算されます)',
      title5: 'オンチェーン報酬収益：{dlc_num} DLC（現在のDLC価格{price} USDで{usdt_num} USDに相当）。',

      req_title1: '5. オンライン検出メカニズム',
      req_text1_1:
        'マシンはDBC AIパブリックチェーンの検出メカニズムの対象であり、DBC分散検出クラスターに情報を報告して、マシンがオンラインであるかどうかを判断します。オンラインでない場合、オンライン報酬が差し引かれます。ユーザーの使用中に中断が発生した場合、DLCがユーザーから差し引かれます。罰則の制限：',
      req_text1_2:
        '1) コインがステークされていない場合、現在のレンタルDLC収益のみがペナルティの対象となり、最大で2時間分のレンタル料が罰せられます。',
      req_text1_3: '2) DLCがステークされている場合、1,000 DLCのペナルティが科されます。',
      req_text1_4:
        'マシンにはDBC AIブロックチェーンの常駐検知メカニズムがあり、情報をDBC分散型検知クラスターに報告してマシンのオンライン状態を判断します。オンラインでない場合、オンライン報酬が差し引かれます。利用中に中断が発生した場合、ユーザーからDLCが差し引かれます。現在、中断ごとに1000 DLCのペナルティが発生し、後ほどDLCの価格に応じて動的に変更されます',
      req_title2: '6. マシン報告ルール',
      req_text2:
        'ユーザーがマシンの構成が不正である可能性があると判断した場合、報告を開始できます。成功した場合、すべてのステーキングコインがマシンから差し引かれ、報酬は停止されます。',
      req_title3: '10,000 DLCをステークして、報告情報をチェーンに送信',
      req_text3:
        'DeepLinkによって認可された検証者が検証に参加できます。各検証には5人の検証者が関与し、過半数の原則に従います。',

      text4_6_1: '第1段階：1日あたり300万DLC。',
      text4_6_2: '第2段階：1日あたり400万DLC。',
      text4_6_3: '第3段階：1日あたり966.5万DLC。',
      text4_6_4: '第4段階：1日あたり966.5万DLC。',
      text4_6_5: '第5段階：1日あたり966.5万DLC。',
    },
  },
  country: {
    country1: '中国',
    country2: '北アメリカ',
    country3: '南アメリカ',
    country4: 'ヨーロッパ',
    country5: '中東',
    country6: '韓国',
    country7: '日本',
    country8: '台湾、中国',
    country9: '香港およびマカオ、中国',
    country10: 'マレーシア',
    country11: 'インドネシア',
    country12: 'シンガポール',
    country13: 'ベトナム',
  },
  device: {
    title: '全ネットワークデバイスリスト',
    title1: '異なるGPUモデルのマシン数、マシンの状態、および詳細情報を確認します。',
    table: {
      text1: '機械の使用状況：',
      text2: 'GPUの数：',
      text3: '機械の総数：',
      text4: 'アイドル状態の機械の数：',
    },
  },
  machine_id: 'マシンID',
  machine_is_rented: 'レンタルされているかどうか',
  machine_rented: 'レンタル済み',
  machine_idle: 'アイドル',
  machine_is_online: 'オンラインかどうか',
  machine_yes: 'はい',
  machine_no: 'いいえ',
  machine_no_data: 'データがありません',

  deviceUniqueId: 'マシンID',
  minerLocation: 'マイナーアドレス',
  gpuCount: 'GPU数量',
  computeCapacity: '総計算能力',
  isActive: 'オンライン状態',
  isPledged: 'ステーキング状態',
  pledgeTotal: 'ステーキング総額',
  pledgeExpiration: 'ステーキング終了時間',

  yesOption: 'はい',
  noOption: 'いいえ',
  gpuType: 'GPUタイプ',
};
